// Kotilinga slides configuration
// Images should be placed under public/assets/images/kotilinga/
// Define your slides below by listing image paths. Headings and subtitles
// are automatically derived from the image file names.
// Example image path: "/assets/images/kotilinga/slide1.jpg"

// Helper: derive a title-cased heading from the file name
function deriveHeadingFromPath(path) {
  try {
    const filename = path.split('/').pop() || '';
    const withoutExt = filename.replace(/\.[^.]+$/, '');
    const normalized = withoutExt
      .replace(/[_-]+/g, ' ') // underscores/dashes to spaces
      .replace(/\s+/g, ' ')   // collapse spaces
      .trim();
    if (!normalized) return 'Kotilinga Kshetram';
    return normalized
      .split(' ')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');
  } catch (e) {
    return 'Kotilinga Kshetram';
  }
}

export const DEFAULT_SUBTITLE = 'UNIQUE GLOBAL HINDU PROJECT';

// List your images here; headings/subtitles are generated below
const kotilingaSlides = [
  // Replace these examples with your real file names
  { image_src: "/assets/images/kotilinga/Kotilinga Kshetram.jpg" }, 
  { image_src: "/assets/images/kotilinga/Kotilinga Kshetram.jpeg" },
   { image_src: "/assets/images/kotilinga/Founders to Museum.jpg" },
   { image_src: "/assets/images/kotilinga/Founders Wall to Pavilion.jpg" },
   { image_src: "/assets/images/kotilinga/Founders Wall.jpg" },
   { image_src: "/assets/images/kotilinga/From Railing.jpg" },
   { image_src: "/assets/images/kotilinga/Museum Closeup.jpg" },
   { image_src: "/assets/images/kotilinga/Museum Entrance.jpg" },
   { image_src: "/assets/images/kotilinga/Museum View.jpg" },
   { image_src: "/assets/images/kotilinga/Manidweepa Mandapam.png" },
   { image_src: "/assets/images/kotilinga/Overall Site.jpg" },
   { image_src: "/assets/images/kotilinga/Pavilion Closeup.jpg" },
   { image_src: "/assets/images/kotilinga/Toward Founders Circle.jpg" },
];

// Produce final slides with derived heading/subtitle
const processedSlides = kotilingaSlides.map(s => ({
  image_src: s.image_src,
  heading: deriveHeadingFromPath(s.image_src),
  subtitle: DEFAULT_SUBTITLE,
}));

export default processedSlides;
